import $ from 'jquery';
import '../../../node_modules/jquery-match-height/jquery.matchHeight';


$(function() {
  $('.p-location__post-heading-wrap').matchHeight();
  $('.p-banquet-chart .js-match-height01').matchHeight();
  $('.p-banquet-chart .js-match-height02').matchHeight();

  
});

